module.exports = __webpack_public_path__ + "static/amaris_terms-and-conditions-17608945a1b1b175c93de67d3f19bec4.pdf";